let parentWindow;

const hasParent = !!((parentWindow = window.opener || window.parent) && parentWindow !== window);
const isWindowOpen = !!(window.opener && window.opener === parentWindow);

export {
  parentWindow,
  hasParent,
  isWindowOpen
}
